/**
 * İlişki öğesinin "Sorun Var/Yok" durumu.
 * API'de string enum olarak tutulur: issue | no_issue | in_review.
 * Bu modül enum değerleri ile UI karşılıkları arasındaki tek eşleme noktasıdır.
 */

/** API enum değerleri — tablo filtresi değeri ve dropdown menü key'i olarak da kullanılır */
export const ISSUE_STATUS = {
  issue: 'issue',
  noIssue: 'no_issue',
  inReview: 'in_review',
};

/** Enum değeri → görünen etiket ve antd Tag rengi. Sıralama hem filtre hem dropdown için geçerlidir. */
export const ISSUE_STATUS_META = {
  [ISSUE_STATUS.issue]: { label: 'Sorun Var', color: 'red' },
  [ISSUE_STATUS.noIssue]: { label: 'Sorun Yok', color: 'green' },
  [ISSUE_STATUS.inReview]: { label: 'İnceleniyor', color: 'orange' },
};

/** Tablo sütununun filters prop'u için hazır seçenek listesi */
export const ISSUE_FILTER_OPTIONS = Object.entries(ISSUE_STATUS_META).map(([value, { label }]) => ({
  text: label,
  value,
}));

/** Sorun durumuna ait query key'i; filtre değişiminde temizlenmesi gerekenler arasında yer alır */
export const ISSUE_FILTER_KEYS = ['hasIssue'];

/**
 * Enum değerinin etiket/renk karşılığını verir.
 * @param {string|null} status - API'den gelen hasIssue değeri
 * @returns {{ label: string, color: string }} Tanınmayan ve null değerler İnceleniyor sayılır
 */
export const getIssueStatusMeta = (status) => (
  ISSUE_STATUS_META[status] ?? ISSUE_STATUS_META[ISSUE_STATUS.inReview]
);
